import React, { useContext } from "react";
import {
  TransactionList as TransactionListComponent,
  Auth as MediastoreAuth,
} from "@cleeng/mediastore-sdk";
import { AuthContext } from "Context/AuthContext";

const TransactionList = (props) => {
  const { isAuthenticated, setIsAuthenticated } = useContext(AuthContext);

  React.useEffect(() => {
    MediastoreAuth.isLogged();
  }, [isAuthenticated]);
  return (
    <div>
      {MediastoreAuth.isLogged() ? (
        <>
          <h1>TransactionList</h1>
          <div id="Sub-Component-TransactionList">
            <TransactionListComponent />
          </div>
        </>
      ) : (
        <>
          <h1>
            In order to see TransactionList component you need to be logged in.{" "}
            <br></br>Please login.
          </h1>
        </>
      )}
    </div>
  );
};

export default TransactionList;
